// extracted by mini-css-extract-plugin
export var desktop = "WTjgX";
export var mobile = "ugmyI";